/* SAMDIYA: keep the header cart badge in sync after custom add-to-cart calls */
(function () {
  function syncCartBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
          el.textContent = count;
          el.classList.toggle('hidden', count === 0);
        });
        document.querySelectorAll('.cart-bubble').forEach(function (el) {
          el.classList.toggle('visually-hidden', count === 0);
        });
        document.querySelectorAll('.cart-badge-count, #samdiya-cart-count, .samdiya-header-cart-badge').forEach(function (el) {
          el.textContent = count;
        });
      })
      .catch(function () {});
  }
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var p = origFetch.apply(this, args);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(syncCartBadge, 150); }).catch(function () {});
    }
    return p;
  };
  window.addEventListener('pageshow', syncCartBadge);
  document.addEventListener('DOMContentLoaded', syncCartBadge);
})();

/* SAMDIYA: scroll-lock safety net.
   The mobile menu drawer sets document.body.style.overflow = 'hidden' while open.
   If the page is left/restored (back button, bfcache) or the drawer is closed by any
   route other than its own close button, that inline lock can survive and the page
   stops scrolling until reload. Clear a stale lock whenever nothing is actually open. */
(function () {
  function releaseStaleLock() {
    var drawer = document.getElementById('samdiya-mobile-drawer');
    var drawerOpen = drawer && drawer.classList.contains('is-open');
    var dialogOpen = document.querySelector('dialog[open]');
    if (!drawerOpen && !dialogOpen) {
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = '';
    }
  }
  window.addEventListener('pageshow', releaseStaleLock);
  window.addEventListener('pagehide', function () { document.body.style.overflow = ''; });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) releaseStaleLock(); });
  window.addEventListener('resize', releaseStaleLock);
  window.addEventListener('orientationchange', releaseStaleLock);
  document.addEventListener('touchstart', releaseStaleLock, { passive: true });
})();
